export function isTruthy<TValue>(
  value: TValue | null | undefined | boolean | number
): value is TValue {
  return !!value
}
